<template>
  <div class='regulamento'>
    <p class='MsoNormalCxSpFirst' align='center' style='text-align: center'>
      REGULAMENTO DO PROJETO MÃES UNIDAS
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      LISTA DE ABREVIATURAS
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      1. CCV- Curso de Capacitação das Voluntárias.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      2. FMA- Formulário de Monitoramento do Atendimento.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      3. GE- Guia do Encontro.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      4. MMFDH- Ministério da Mulher, da Família e dos Direitos Humanos.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      5. PMU - Projeto Mães Unidas.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      6 . SNPM- Secretaria Nacional de Políticas para as Mulheres.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      TÍTULO I - DAS DISPOSIÇÕES GERAIS
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 1º O Projeto &quot;Mães Unidas&quot; (PMU) tem por objetivo oferecer
      apoio relacional à gestantes e mães de crianças com até 2 (dois) anos de
      idade, por meio do acompanhamento de mães voluntárias, bem como promover o
      fortalecimento de vínculos familiares, a saúde e a cidadania dessas
      mulheres e crianças.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Parágrafo único. A Administração do PMU será realizada pela Secretaria
      Nacional de Políticas para as Mulheres, do Ministério da Mulher, da
      Família e dos Direitos Humanos (SNPM/MMFDH).
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 2º Para efeitos deste Regulamento, considera-se:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - serviço voluntário: o oferecimento de apoio relacional e orientação de
      outras mães e gestantes em situação de vulnerabilidade sobre o acesso aos
      serviços básicos de saúde, assistência social e de justiça;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - voluntária: aquela que, tendo vivenciado a experiência da maternidade,
      habilita-se para exercer o trabalho voluntário com gestantes e mães em
      situação de vulnerabilidade, preenchidos os seguintes requisitos:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      a. ser mãe de pelo menos um filho, não se diferenciando mães biológicas de
      mães adotivas;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      b. ter idade mínima de 18 anos;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      c. ter escolaridade mínima de ensino fundamental completo;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      d. ter concluído e ter sido aprovada no Curso de Capacitação de
      Voluntárias;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      e. assinar termo de adesão ao projeto; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      f. não estar em cumprimento de pena decorrente de crimes previstos na Lei
      Maria da Penha (Lei nº 11.340, de 7 de agosto de 2006) ou do Estatuto da
      Criança e do Adolescente (Lei nº 8.069, de 13 de julho de 1990).
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - beneficiária: aquela que será acompanhada pela mãe voluntária, estando
      gestante ou sendo mãe de criança de até 2 anos, tendo prioridade de
      atendimento os seguintes casos:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      a. gestantes e mães adolescentes de até 19 anos;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      b. gestantes e mães beneficiárias do Programa Bolsa Família; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      c. gestantes e mães de crianças com deficiência.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - tutor: aquele responsável pelo gerenciamento das voluntárias a nível
      municipal, devendo, dentre outras atribuições, estar disponível para tirar
      dúvidas, resolver demandas concernentes ao serviço voluntário, designar os
      locais de atendimento no Município e informar sobre a existência e
      localização da rede de atendimento à saúde, de assistência social e de
      justiça;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - gestor: o responsável pela adesão do Município ao PMU e por designar um
      ou mais Tutores para o Projeto; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - administração: equipe composta pelos servidores determinados pela
      Secretaria Nacional de Políticas para as Mulheres (SNPM/MMFDH).
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Parágrafo único. O requisito previsto na alínea &quot;f&quot;, do inciso
      II, faz-se necessário uma vez que, o Projeto tem como público alvo
      mulheres e crianças, prevendo no seu Curso de Capacitação a identificação
      de situações de violência contra esses grupos, sendo incompatível portanto
      que, a voluntária esteja respondendo penalmente por crimes desta natureza.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      TÍTULO II - DA VOLUNTÁRIA
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção I - Do ingresso e da desistência da voluntária
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 3º Aquela que desejar ingressar no PMU como voluntária, deverá
      realizar seu cadastro na plataforma digital do Projeto, ocasião em que
      deverá comprovar os requisitos previstos no art. 2º, II, alíneas
      &quot;a&quot; a &quot;f&quot;.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §1º Enquanto não concluir o Curso de Capacitação de Voluntárias (CCV), a
      candidata ficará com seu cadastro suspenso, aguardando que sua aprovação
      seja lançada no sistema.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §2º A voluntária responsabilizar-se-á pela veracidade de todas as
      informações lançadas na plataforma digital do Projeto, sujeitando-se às
      sanções civis e penais em caso de inserção de informações falsas.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §3º Caso não seja aprovada no CCV, a candidata poderá refazer as aulas e a
      avaliação final.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 4º Uma vez aprovada no Curso de Capacitação de Voluntárias, e
      liberado seu acesso ao sistema, a voluntária deverá cadastrar sua
      disponibilidade de dias e horários para atendimento de beneficiárias.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §1º A voluntária precisará cadastrar no mínimo um dia e horário disponível
      por semana para atendimento individual de beneficiária.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §2º Cada voluntária deverá atender, individualmente, no mínimo uma e no
      máximo 4 (quatro) beneficiárias por mês.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §3º Cada encontro individual com a beneficiária terá duração de 45
      (quarenta e cinco) minutos, e será orientado pelo Guia do Encontro (GE).
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §4º Após cada encontro individual, a voluntária deverá preencher e enviar
      o Formulário de Monitoramento do Atendimento (FMA) na plataforma digital
      do PMU.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 5º A voluntária deve também cadastrar sua disponibilidade de
      participar em, no mínimo, três encontros no formato roda de conversa, num
      período de 12 meses.
    </p>

    <p class='MsoNormalCxSpMiddle' v-if="false" style='text-align: justify'>
      §1º As Rodas de Conversa ocorrerão duas vezes por mês, cabendo à
      beneficiária e à voluntária escolher em qual dia daquele mês poderá
      participar.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §2º Após a apresentação do tema do mês por um especialista, as
      beneficiárias participantes serão divididas em grupos de partilha temática
      a fim de, conversarem sobre o assunto exposto.
    </p>

    <p class='MsoNormalCxSpMiddle' v-if="false" style='text-align: justify'>
      §3º Nas Rodas de Conversa, a voluntária deverá disponibilizar-se como
      facilitadora de um dos grupos de partilha temática, utilizando o Guia do
      Encontro.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 6º Aquela que desejar desistir de participar do PMU como voluntária,
      deverá acessar a plataforma digital do Projeto e informar motivo para
      tanto.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Parágrafo único. Aquelas que desistirem do Projeto não poderão retornar
      antes de um prazo transcorrido de seis meses, devendo informar se os
      motivos para a última desistência foram solucionados.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção II - Dos direitos e benefícios da voluntária
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 7º São direitos da voluntária:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - ter a descrição clara de suas tarefas e responsabilidades, inclusive
      quanto ao canal para esclarecimento necessário de suas dúvidas;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - receber capacitação, supervisão e avaliação técnica nas atividades que
      desempenha;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - receber reconhecimento e estímulo;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - encaminhar por escrito, sugestões, críticas ou elogios pertinentes ao
      Projeto e/ou ao voluntariado, ou reclamar providências sobre
      irregularidades que se deem no desenvolvimento do PMU;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - requerer relatório de suas atividades exercidas;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - cancelar agendamento de atendimento, justificando o ocorrido com um
      prazo mínimo de 24 horas de antecedência; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - desistir de participar do PMU, justificando sua saída.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 8º Durante a permanência da voluntária no PMU, a mesma gozará dos
      seguintes benefícios:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - certificado de relevantes serviços prestados emitido pelo Ministério da
      Mulher, da Família e dos Direitos Humanos, após 1 ano de serviço
      voluntário; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - outros incentivos a critério do Município aderente.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção III - Das responsabilidades da voluntária
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 9º O trabalho voluntário precisa ser realizado com responsabilidade,
      interesse, disponibilidade e empenho. A voluntária deve, portanto,
      dedicar-se no estudo dos temas abordados no Curso de Capacitação de
      Voluntárias, no Guia do Encontro e nos materiais que serão enviados
      periodicamente por meio da plataforma digital &quot;Mães Unidas&quot;.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 10. A voluntária se responsabiliza pela veracidade de todas as
      informações fornecidas ao Projeto &quot;Mães Unidas&quot;, especialmente
      quanto aos dados fornecidos no seu cadastro e nos Formulários de
      Monitoramento do Atendimento (FMA).
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 11. A voluntária compromete-se a guardar sigilo quanto a tudo que for
      conversado com a beneficiária durante os atendimentos, prestando
      informações externas apenas por meio do FMA ou quando for solicitada pela
      Administração do PMU.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 12. São obrigações da voluntária:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - ler e assinar o Termo de Adesão do Voluntário, observando todos os
      compromissos firmados durante sua permanência no PMU, bem como estar
      ciente das normas previstas na Lei nº 9.608, de 18 de fevereiro de 1998
      (Lei do Serviço Voluntário);
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - ser assídua e pontual, evitando ao máximo cancelar, faltar ou atrasar
      nos atendimentos;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - em caso de necessidade, cancelar o atendimento com pelo menos 24 horas
      de antecedência, justificando no sistema as razões para o não
      comparecimento, podendo anexar documentos comprobatórios em até 48 horas
      após o cancelamento;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - ser acolhedora e estar atenta à beneficiária, evitando interrupções
      durante o atendimento ou ter qualquer outro comportamento que demonstre
      falta de atenção para com a beneficiária;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - evitar linguagem inadequada durante os atendimentos, tais como piadas,
      sarcasmo, obscenidades e atitude crítica ou julgadora;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - manter o devido distanciamento pessoal da beneficiária, evitando
      fornecer seu número de celular, endereço ou encontrar-se com a mesma fora
      dos horários e locais determinados para o atendimento; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - informar a realização do atendimento no sistema, enviando o FMA dentro
      de até 72 horas após a sua conclusão.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 13. É vedado à voluntária:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - constranger a beneficiária com atitudes de caráter político partidário
      ou religioso;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - receitar ou administrar medicamento ou terapia, devendo, caso perceba a
      necessidade, orientar a beneficiária para que busque o serviço de saúde;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - tratar de interesses particulares dentro do Projeto;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - transportar crianças e seus acompanhantes em ônibus, vans, veículos
      particulares e afins, para qualquer atividade externa ao Projeto
      &quot;Mães Unidas&quot;, sem autorização;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - distribuir alimentos, balas e/ ou guloseimas de qualquer espécie, bem
      como presentes, roupas etc., sem autorização do Tutor ou da Administração
      do Projeto;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - organizar qualquer tipo de evento que envolva o Projeto &quot;Mães
      Unidas&quot; sem conhecimento prévio e aprovação da Administração do PMU;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - receber remuneração de qualquer espécie pela atividade voluntária;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - fazer uso de imagem, áudio, vídeo ou qualquer dado obtido no exercício
      do serviço voluntário, em proveito próprio ou não, sem que haja
      autorização expressa da Administração, perante qualquer mídia escrita,
      sonora ou televisiva; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - dar informações à imprensa falada, escrita ou televisiva, sobre fatos ou
      acontecimentos referentes ao Projeto &quot;Mães Unidas&quot; e seus
      acompanhantes, sem prévia autorização escrita da Administração.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 14. Na hipótese de cancelamento ou falta injustificada ao
      atendimento, a voluntária terá um crédito de abono descontado, limitados a
      três créditos em 12 meses.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §1º Os créditos de abono estabelecem o limite de vezes em que a voluntária
      e a beneficiária podem cancelar ou faltar, sem justificativa válida, a um
      encontro individual ou roda de conversa num prazo de 12 meses.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §2º Cancelamentos justificados no sistema não gerarão a penalidade de
      desconto de crédito de abono.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 15. A voluntária poderá solicitar desvinculação da beneficiária,
      hipótese em que não mais prestará atendimento àquela beneficiária
      específica, escolhendo um dos seguintes motivos:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - a beneficiária me agrediu fisicamente ou verbalmente;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - a beneficiária atrasa-se ou encerra o atendimento antes de terminar o
      tempo previsto com frequência; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - outros motivos.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção IV - Das sanções
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 16. A voluntária será suspensa do PMU nas seguintes hipóteses:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - faltar ou desmarcar encontro individual com a beneficiária, sem
      justificativa, por mais de 3 vezes no período de 12 meses;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - faltar ou desmarcar participação em roda de conversa, sem justificativa,
      por mais de 2 vezes no período de 12 meses;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - receber, no aplicativo &quot;Mães Unidas&quot;, 7 avaliações de duas ou
      menos estrelas por parte das beneficiárias que atende; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - incidir nas vedações previstas no art. 13, a critério do Tutor ou da
      Administração do PMU.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Parágrafo único. O período de suspensão de que trata os incisos do art. 16
      durará até que a voluntária se justifique para o Tutor local.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 17. A voluntária será desligada do PMU nas seguintes hipóteses:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      I- transcorridos 30 dias sem que a justificação referida no § 1º do art.
      16 tenha sido realizada, ou, se realizada, não tenha sido aceita pelo
      Tutor.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      II - não estar em cumprimento de pena decorrente de crimes previstos na
      Lei Maria da Penha (Lei nº 11.340, de 7 de agosto de 2006) ou do Estatuto
      da Criança e do Adolescente (Lei nº 8.069, de 13 de julho de 1990), de
      acordo com a justificativa prevista no parágrafo único do
      <span class='SpellE'>art</span> 2º.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Parágrafo único. Aquela que for desligada do Projeto, somente poderá
      retornar após transcorrido prazo mínimo de seis meses, apresentando
      justificativa de interesse em retornar.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      TÍTULO III - DA BENEFICIÁRIA
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção I - Do ingresso e da desistência da beneficiária
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 18. Aquela que desejar ingressar no PMU como beneficiária, deverá
      realizar seu cadastro na plataforma digital do Projeto, ocasião em que
      deverá comprovar os requisitos previstos no art. 2º, inciso III.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 19. Após validação do seu cadastro, a beneficiária deverá selecionar
      em qual dia da semana, local, e horário poderá ser atendida por uma
      voluntária.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §1º A voluntária que atenderá a beneficiária será selecionada
      automaticamente pelo sistema, não cabendo à beneficiária referida escolha.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §2º O sistema marcará automaticamente os encontros a cada 4 semanas, no
      dia e horário selecionado pela beneficiária.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção II- Dos direitos e benefícios da beneficiária
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 20. São direitos da beneficiária:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - receber informações claras a respeito dos horários e locais de
      atendimento, bem como sobre a identidade da voluntária que lhe atenderá;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - o sigilo quanto às suas informações fornecidas durante o atendimento,
      sendo estas encaminhadas somente por meio do FMA, resguardando sua
      identidade pessoal;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - encaminhar, por escrito, ao Projeto &quot;Mães Unidas&quot;, sugestões,
      críticas ou elogios pertinentes ao Projeto, ou reclamar providências sobre
      irregularidades que tenha observado;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - cancelar agendamento de atendimento, justificando o ocorrido e com um
      prazo mínimo de 24 horas de antecedência;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - ser atendida por outra voluntária caso aquela que estava prestando-lhe
      atendimento pedir desistência ou for desligada do Projeto; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - desistir de participar do PMU, justificando sua saída.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Parágrafo único. O direito referido no inciso V será atendido mediante
      disponibilidade de voluntárias no Município, ficando a beneficiária, se
      necessário, em lista de espera.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 21. Durante a permanência da beneficiária no PMU, a mesma gozará dos
      seguintes benefícios:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - receberá a &quot;Caixa do Bebê&quot;, devendo ser comprovada a
      assiduidade e pontualidade nos atendimentos com a voluntária; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - outros incentivos a critério do Município aderente.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §1º Os benefícios descritos nos incisos I e II deste artigo serão
      entregues mediante disponibilidade do produto, a critério da
      Administração.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §2º A assiduidade a que se refere o inciso I do caput deste artigo será
      verificada pela voluntária, devendo a beneficiária comparecer a todos os
      atendimentos, justificando sua ausência em casos de cancelamento, devendo
      ainda, caso esteja grávida, comprovar que compareceu regularmente às
      consultas do pré-natal.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção III- Das responsabilidades da beneficiária
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 22. A beneficiária compromete-se a participar do PMU, sendo assídua e
      pontual aos encontros, buscando seguir as orientações transmitidas pela
      voluntária.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 23. A beneficiária se responsabiliza pela veracidade de todas as
      informações fornecidas para o Projeto Mães Unidas, especialmente quanto
      aos dados fornecidos no seu cadastro e durante os atendimentos com a
      voluntária.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 24. A beneficiária deverá reportar ao Tutor responsável qualquer
      irregularidade de conduta por parte da voluntária que lhe presta
      atendimento, ou no desenvolvimento do Projeto.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção IV- Das sanções
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 25. A beneficiária será suspensa do PMU nas seguintes hipóteses:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - faltar ou desmarcar encontro individual com a voluntária sem
      justificativa por mais de 3 vezes no período de 12 meses; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - faltar ou desmarcar participação em roda de conversa sem justificativa
      por até 3 vezes no período de 12 meses.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §1º O período de suspensão de que trata os incisos do art. 24 durará até
      que, a beneficiária justifique para o Tutor o motivo das ausências.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §2º Transcorridos 30 dias sem que a justificação referida no §1º tenha
      sido realizada, ou, se realizada, não aceita pelo Tutor, a beneficiária
      será excluída do PMU.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      §3º Aquela que for excluída do Projeto, somente poderá retornar
      transcorrido prazo mínimo de seis meses, apresentando justificativa de
      interesse em retornar.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      TÍTULO IV - DO TUTOR
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção I - Das responsabilidades
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 26. Caberá ao Tutor:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - cuidar das voluntárias do seu Município, esclarecendo dúvidas, ouvindo e
      dando encaminhamento às críticas, sugestões e elogios ao Projeto;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - <span class='SpellE'>fornecer</span> informações precisas e atualizadas
      sobre a existência e localização da rede de atendimento em saúde, serviço
      social e justiça;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - designar os locais para realização dos atendimentos da voluntária, bem
      como das rodas de conversa;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - validar o cadastro das voluntárias e beneficiárias em seu Município;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - validar, em 48 horas, a justificativa enviada pela voluntária ou
      beneficiária para cancelar atendimento individual;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - organizar periodicamente encontros de voluntárias para troca de
      experiências e esclarecimento de dúvidas recorrentes;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - designar outros tutores para auxiliá-lo nas gestão das voluntárias e das
      beneficiárias do seu Município; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - reportar ao Gestor ou à Administração do PMU todas as situações que
      julgar pertinentes e que cuja resolução esteja fora de seu alcance.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção II- Das Vedações
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 27. É vedado ao Tutor:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - constranger a voluntária ou a beneficiária com atitudes de caráter
      político partidário ou religioso;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - tratar de interesses particulares dentro do Projeto;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - transportar crianças e seus acompanhantes em ônibus, vans, veículos
      particulares e afins, para qualquer atividade externa ao Projeto Mães
      Unidas, sem autorização da Administração;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - distribuir alimentos, balas e/ou guloseimas de qualquer espécie, bem
      como presentes, roupas, etc., sem autorização da Administração do Projeto;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - organizar qualquer tipo de evento que envolva o Projeto &quot;Mães
      Unidas&quot; sem conhecimento prévio e aprovação da Administração do PMU;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - receber remuneração de qualquer espécie pela atividade voluntária;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - fazer uso de imagem, áudio, vídeo ou qualquer dado obtido no exercício
      do serviço voluntário, em proveito próprio ou não, sem que haja
      autorização expressa da Administração, perante qualquer mídia escrita,
      sonora ou televisiva; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - dar informações à imprensa falada, escrita ou televisiva, sobre fatos ou
      acontecimentos referentes Projeto &quot;Mães Unidas&quot; e seus
      acompanhantes, sem prévia autorização escrita da Administração.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      TÍTULO V - DO GESTOR
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção I - Das responsabilidades
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 28. Caberá ao Gestor:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - manifestar interesse em aderir ao Projeto Mães Unidas, mediante
      assinatura de Acordo de Cooperação Técnica com a Administração do Projeto;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - designar um ou mais Tutores locais para acompanhamento do Projeto em
      nível municipal;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - efetuar a exclusão do Tutor Líder do seu Município, substituindo-o por
      outro, conforme sua decisão discricionária, comunicando as razões à
      Administração; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - caso deseje encerrar o Projeto em seu município, informar à
      Administração as razões para tanto, com um prazo mínimo de 60 dias de
      antecedência.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Seção II- Das Vedações
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 29. É vedado ao Gestor:
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - constranger a voluntária ou a beneficiária com atitudes de caráter
      político partidário ou religioso;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - tratar de interesses particulares dentro do Projeto;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - organizar qualquer tipo de evento que envolva o Projeto &quot;Mães
      Unidas&quot; sem conhecimento prévio e aprovação da Administração do PMU;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - receber remuneração de qualquer espécie pela atividade voluntária;
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - fazer uso de imagem, áudio, vídeo ou qualquer dado obtido no exercício
      do serviço voluntário, em proveito próprio ou não, sem que haja
      autorização expressa da Administração, perante qualquer mídia escrita,
      sonora ou televisiva; e
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      - dar informações à imprensa falada, escrita ou televisiva, sobre fatos ou
      acontecimentos referentes ao Projeto &quot;Mães Unidas&quot; e seus
      acompanhantes, sem prévia autorização escrita da Administração.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      TÍTULO VI- DA PLATAFORMA DIGITAL
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 30. Qualquer interessado poderá fazer o download do aplicativo
      &quot;Mães Unidas&quot;, ou acessar o site do Projeto para obter
      informações sobre seu funcionamento.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 31. O acesso à área restrita às beneficiárias, voluntários, tutores e
      gestores será feita mediante cadastro, seguido de validação e fornecimento
      de <span class='SpellE'>login</span> e senha.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 32. A Administração do PMU terá a função de gerenciar todos os perfis
      mencionados no art. 30, bem como os dados da plataforma digital do
      Projeto.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 33. A inserção de informações falsas na plataforma digital acarretará
      na suspensão ou desligamento do responsável do Projeto, sem prejuízo das
      sanções civis e penais cabíveis.
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      <o:p>&nbsp;</o:p>
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      TÍTULO VII- DAS DISPOSIÇÕES FINAIS
    </p>

    <p class='MsoNormalCxSpMiddle' style='text-align: justify'>
      Art. 34. O PMU coletará dados das participantes voluntárias e
      beneficiárias, para fins de monitoramento da política pública e
      compilações estatísticas, preservando-se o sigilo da identidade da
      beneficiária.
    </p>

    <p class='MsoNormalCxSpLast' style='text-align: justify'>
      Art. 35. Casos não especificados neste regulamento serão resolvidos pela
      Administração do Projeto.
    </p>
  </div>
</template>
<script>
export default {
  name: 'Regulamento'
}
</script>


// WEBPACK FOOTER //
// src/templates/site-externo/Regulamento.vue